<template>
  <form ref="form">
    <div class="question-text" v-html="getQuestionText"></div>
    <div v-for="(choice, index) in getChoices" :key="index" :class="{ 'spaced': choice.spaced }">
      <div class="input-group" :class="isChecked(choice.id)">
        <label :for="`input_checkbox_`+choice.id">
          <span v-html="getChoiceText(choice.id)"></span>
          <input
            type="range"
            :name="data.id"
            :id="`input_checkbox_`+choice.id"
            min="0"
            max="100"
            step="10"
            list="values"
            value="0"
            @input="updateOutput(choice.id, $event.target.value)"
          >

          <output :ref="`range${choice.id}`">0</output>
        </label>
      </div>
    </div>

    <div class="total">
      <span>Total:</span>
      <span>{{ total }}</span>
    </div>

    <div>
      <datalist id="values">
        <option value="0" label="0%"></option>
        <option value="50" label="50%"></option>
        <option value="100" label="100%"></option>
      </datalist>
    </div>

    <button type="button" class="previous" @click="prev">Previous</button>
    <button
      @click.prevent="next"
      :disabled="nextBtnDisabled"
      :class="{ active: !nextBtnDisabled }"
      class="next"
    >Next</button>

  </form>
</template>

<script>
export default {
    name: 'slider-choice',

    props: {
      data: {
        required: true,
        type: Object
      }
    },

    data() {
        return {
            nextBtnDisabled: true,
            answer: {
              question: this.data.id,
              choices: []
            },
            total: 0,
        }
    },

    mounted(){
      if ( this.data.randomize ){
        const head = this.data.choices.filter(item => {
          return item.text[this.$parent.lang].html.substr(0,1) !== '['
        })
        head.sort(() => Math.random() - 0.5)
        const tail = this.data.choices.filter(item => {
          return item.text[this.$parent.lang].html.substr(0, 1) === '['
        })
        this.data.choices = [...head, ...tail]
      }
    },

    methods: {
        updateOutput(choiceId, value) {
          let index = this.answer.choices.findIndex(c => c.id === choiceId)
          if ( index !== -1 ){
            this.answer.choices.splice(index,1)
          }
          this.answer.choices.push({id: choiceId, custom: value})

          this.$refs[`range${choiceId}`][0].innerHTML = value
          this.total = this.answer.choices.map(c => c.custom).reduce((acc, cur) => parseInt(acc) + parseInt(cur), 0)

          if ( this.total > 100 ){
            document.getElementById(`input_checkbox_${choiceId}`).value = 0;
            let index = this.answer.choices.findIndex(c => c.id === choiceId)
            if ( index !== -1 ){
              this.answer.choices.splice(index,1)
            }
            this.$refs[`range${choiceId}`][0].innerHTML = 0
            this.total = this.answer.choices.map(c => c.custom).reduce((acc, cur) => parseInt(acc) + parseInt(cur), 0)
          }
        },

        next(){
          this.$emit('next-question', this.answer)
        },

        prev() {
          this.$emit('prev-question');
        },

        isChecked(choiceId) {
          return this.answer.choices.find(c => c.id === choiceId) ? 'active' : '';
        },

        getChoiceText(choiceId) {
          const index = this.data.choices.findIndex(c => c.id == choiceId);
          const textIndex = this.data.choices[index].text.findIndex(t => t.lang == this.$parent.lang);
          return this.data.choices[index].spaced ? this.data.choices[index].text[textIndex].html.substr(1) : this.data.choices[index].text[textIndex].html;
        }
    },

    computed: {
      getQuestionText() {
        const index = this.data.text.findIndex(t => t.lang == this.$parent.lang)
        return this.data.text[index].html;
      },

      getChoices() {
        let nchoices = [];
        let answers = this.$parent.answers;
        let doifs = this.data.doifs;
        let hides = [];
        if ( doifs !== false ){
          doifs.forEach(d => {
            let group = d.group;
            group.forEach(g => {
              answers.forEach(a => {
                a.choices.forEach(ch => {
                  if(ch.id == g.idchoice && ch.custom == g.value){
                    hides.push(g.hide)
                  }
                });
              });
            })
          })
        }
        if ( hides.length > 0 ){
          nchoices = this.data.choices.filter(choice => {
            return ! hides.includes(choice.id)
          });
          return nchoices;
        } else {
          return this.data.choices;
        }
      }
    },

    watch: {
      'total': function(val) {
        this.nextBtnDisabled = true;

        if ( val == 100 )
          this.nextBtnDisabled = false;
      }
    }
}
</script>

<style scoped>
label > span:first-child {
  display: flex;
  width: 40%;
}
label input {
  flex: 1;
}

label output {
  width: 20px;
  margin-left: 20px;
  font-size: 16px;
}

.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  padding: 10px 5px;
  font-weight: bold;
  border-top: 2px solid rgba(200, 200, 200, .6);
}
</style>